/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Contact } from '../../models/contact';

export interface GetContactsByCase$Json$Params {

/**
 * id of the case to which the contacts are associated
 */
  caseId: number;
}

export function getContactsByCase$Json(http: HttpClient, rootUrl: string, params: GetContactsByCase$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Contact>>> {
  const rb = new RequestBuilder(rootUrl, getContactsByCase$Json.PATH, 'get');
  if (params) {
    rb.path('caseId', params.caseId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<Contact>>;
    })
  );
}

getContactsByCase$Json.PATH = '/api/Case/{caseId}/Contacts';
